module.exports = __webpack_public_path__ + "media/images/ac_templates/201-overlay-cc6b6bec2c26bc35aac3568b1a3e932a.png";